import { SVGProps } from 'react';

const SvgChevronLeftSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M9.354 4.646a.5.5 0 0 1 0 .708L6.707 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgChevronLeftSmall;
